<section class="hbe" [attr.data-tipo]="tipo">
  @if (titulo) {
    <h5 class="hbe__titulo">{{ titulo }}</h5>
  }

  @switch (tipo) {
    @case ("hechos") {
      <dl class="hbe__hechos">
        @for (item of hechos; track $index) {
          <div class="hbe__hecho">
            <dt>{{ item.etiqueta }}</dt>
            <dd>
              <span>{{ item.valor }}</span>
              @if (estado(item.estado); as e) {
                @if (e !== "neutro") {
                  <span class="hbe__chip" [attr.data-estado]="e">{{ estadoTexto(e) }}</span>
                }
              }
            </dd>
          </div>
        }
      </dl>
    }
    @case ("tabla") {
      <div class="hbe__tabla-caja">
        <table class="hbe__tabla">
          <thead>
            <tr>
              @for (columna of columnas; track $index) {
                <th scope="col">{{ columna }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (fila of filas; track $index; let i = $index) {
              <tr [attr.data-estado]="estadoFila(i)">
                @for (celda of fila; track $index) {
                  <td>{{ celda }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @case ("lista") {
      <ul class="hbe__lista">
        @for (item of lista; track $index) {
          <li>{{ item }}</li>
        }
      </ul>
    }
    @case ("texto") {
      <p class="hbe__texto">{{ texto }}</p>
    }
    @default {
      <p class="hbe__desconocido">Bloque no soportado por esta versión de COS{{ tipo ? " (" + tipo + ")" : "" }}.</p>
    }
  }
</section>
